module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--learn@2x-d461f35362c5be4381742172f4135d0f.jpg";